module.exports = {
  returnName: {
    0: 'Selecione',
    1: 'Consulta',
    2: 'Alteração',
  },
  returnPermissaoForTipoPerfilUsuario: {
    ContratanteConsulta: 'Consulta',
    ContratanteAlteracao: 'Alteração',
  },
  returnTipoPerfilUsuarioForPermissao: {
    Consulta: 'ContratanteConsulta',
    Alteração: 'ContratanteAlteracao',
  },
};
